import { DialogHeader, DialogTitle } from "design-system/dialog";
import { Skeleton } from "design-system/skeleton";

// Loading placeholder for the create-wallet dialog. The destination flow isn't known until the routing data
// resolves, so instead of a concrete title that would flip once it does ("Set up your wallet" -> "Welcome
// back"/"Add an account"), show a title + body skeleton. A visually hidden DialogTitle keeps Radix's
// labelling contract. Shared by the dialog's lazy-import fallback and the coordinator's own loading route, so
// the modal shows one continuous skeleton from open through routing.
export function WalletSetupSkeletonView() {
  return (
    <>
      <DialogHeader>
        <DialogTitle className="sr-only">Setting up your wallet</DialogTitle>
        <Skeleton className="h-6 w-44" data-testid="wallet-setup-skeleton" />
      </DialogHeader>
      <div className="space-y-3 py-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-11/12" />
        <Skeleton className="h-4 w-2/3" />
      </div>
      <Skeleton className="h-10 w-full" />
    </>
  );
}
